<template>
  <div id="app">
    <router-view :key="changequery" v-if="isRouterAlive" />
  </div>
</template>

<script>
  import browser from '@/utils/browser.js'
  /* import header from "./pages/layout/header"; */
  import '@/assets/css/reset.less'
  import '@/assets/css/public.less'
  import '@/assets/css/color.less'

  export default {
    provide() { //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。                                             
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isMobile: browser.mobile,
        isRouterAlive: true, //控制视图是否显示的变量
        changequery:''
      }
    },
    methods: {
      reload() {
        this.isRouterAlive = false; //先关闭，
        this.$nextTick(function () {
          this.isRouterAlive = true; //再打开
        })
      }
    },
    watch: {
      '$route'(newid,oldid){
        console.log(newid,oldid)
        if(newid!== oldid){
          this.changequery = this.$route.query.id;
        }
      }
    }

  }
</script>

<style lang="less">
* {
   user-select: none;
}
  #app {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
</style>
